import Navbar from './components/Navbar/navbar';
import Home from './components/Home/home';
import About from './components/About/about';
import Experience from './components/Experience/experience';
import Skills from './components/Skills/skills';
import Projects from './components/Projects/projects';
import Achievements from './components/Achievements/achievements';
import Contact from './components/Contact/contact';
function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Experience />
      <Skills />
      <Projects />
      <Achievements />
      <Contact />
    </div>
  );
}
export default App;
